/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 4-7-19.
 */
import React from "react";
import Promise from "bluebird";
import {instanceVariables, processInstance, setInstanceVariable} from "../../../../../../api/process/process/processes";
import {Forms} from "../../../../../../api/form/FormClient";
import QuestionForm from "../../../../../component/QuestionForm/smart/QuestionForm";
import {retrieveForm} from "../../../../../../action/creator/asynchonous/form/retrieveForm";
import {CircularProgress, Typography, withStyles} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardMediaHeader from "../../../../../component/CardMediaHeader/CardMediaHeader";
import {push} from "react-router-redux";
import {paths} from "../../../../../paths";
import insuranceProcessClient from "../../../../../../api/process/insuranceProcess/InsuranceProcessClient";
import {cleanupVariables} from "../../../util";
import {compose} from "redux";
import {connect} from "react-redux";
import {noteClient} from "../../../../../../api/relation/note/NoteClient";
import {currentUser} from "../../../../../../state/selector/user";
import * as ReactDOMServer from "react-dom/server";
import ConfirmationNote from "./ConfirmationNote";
import {promiseAction} from "../../../../../../middleware/promiseDispatch";
import {closeTask} from "../../../../../../api/process/task/tasks";
import {getQuestionValue} from "../../../../../../util/form";

const styles = theme => ({
    card: {paddingLeft: "24px"},
});

const getNotes = customer => noteClient.getNotes(customer);

const pickCustomer = variables => variables.customer ? variables.customer : variables.privateCustomer;

class CustomerApproveGarantie extends React.Component {

    state = {
        instance: null,
        agent: null,
        customer: null,
        request: null,
        notes: [],
    };

    componentDidMount() {
        const {task} = this.props;
        const {processInstanceId} = task;

        Promise.all([processInstance(processInstanceId),
            instanceVariables(processInstanceId)])
            .spread((instance, variables) => {
                this.setState({
                    instance,
                    agent: cleanupVariables(variables).agent,
                    customer: pickCustomer(cleanupVariables(variables)),
                    request: cleanupVariables(variables).form,
                });
            })
            .then(() => getNotes(this.state.customer).then(notes => this.setState({notes})));
        this.props.loadForm();
    }

    render() {
        const {customer, notes} = this.state;
        const {task, classes} = this.props;

        if (this.state.instance && this.state.agent) {
            const approve = form => {

                const setVariablesPromise = getQuestionValue(form)("akkoord_av") === "Ja"
                    ? Promise.all([
                        setInstanceVariable(task.processInstanceId)(
                            "String",
                            "handtekening_klant",
                            getQuestionValue(form)("handtekening_klant")),
                        setInstanceVariable(task.processInstanceId)("Boolean", "AkkoordAlgemeneVoorwaarden", true),
                        noteClient.addSystemNote(customer, "Opdracht bevestigd",
                            ReactDOMServer.renderToStaticMarkup(
                                <ConfirmationNote signature={getQuestionValue(form)("handtekening_klant")}
                                                  customer={customer}/>))
                    ])
                    : noteClient.addSystemNote(customer,
                        "Opdracht geannuleerd",
                        "De klant is niet akkoord met de algemene voorwaarden");

                return promiseAction(setVariablesPromise.then(_ => closeTask(task))
                    .then(_ => push(paths.thanksForSignatureBankgarantie)));
            };

            return notes ? [
                <Card key={1}>
                    <CardMediaHeader title={`Actie ${task ? task.name : ""}`}
                                     image="/images/handshake.jpg"/>

                    <div className={classes.card}>
                        <Typography key="0"
                                    variant="h5">
                            Bevestiging aanvraag bankgarantie
                        </Typography>

                        <br/>
                        <QuestionForm endpoint={Forms.customerApprovalBankgarantie}
                                      submitAction={approve}
                                      stepPromise={Promise.resolve}/>
                    </div>
                </Card>
            ] : <CircularProgress/>;
        }
        return <div/>;
    }
}

const mapStateToProps = state => ({
    user: currentUser(state),
});

const mapDispatchToProps = dispatch => ({
    back: task => () => dispatch(push(paths.task)),
    completeTask: task => () => insuranceProcessClient.completeTask(task.id),
    loadForm: () => dispatch(retrieveForm(Forms.customerApprovalBankgarantie)), dispatch,
});

const decorate = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
);

export default decorate(CustomerApproveGarantie);
